module.exports = __webpack_public_path__ + "static/media/webdev.8dfad791.svg";